/**
 * ═══════════════════════════════════════════════════════════════════
 *  useTour — Hook to consume tour context
 * ═══════════════════════════════════════════════════════════════════
 *
 *  Returns:
 *    { startTour, nextStep, prevStep, skipTour, completeTour,
 *      goToStep, pauseTour, resumeTour, resetTour,
 *      currentStep, stepIndex, totalSteps, isActive, status }
 */

import { useContext } from 'react';
import TourContext from './TourContext';

export default function useTour() {
  const ctx = useContext(TourContext);
  if (!ctx) {
    throw new Error('useTour must be used within a <TourProvider>');
  }
  return ctx;
}
